import { type AppContext } from 'vue'

let _appContext: AppContext | null = null

export function setAppContext(ctx: AppContext) {
  _appContext = ctx
}

export function getAppContext() {
  return _appContext
}